import React from 'react';
import { Icon } from '@gumtree/ui-library';
import { trackGtmEvent } from '@gumtree/shared/src/util/gtm-tracker';

import { StyledShowMoreContainer } from './show-more-toggle.style';

const ShowMoreToggle = ({
    maxLengthOfDescendentCategories,
    maxLengthOfAbbreviatedDescendentList,
    isShowFullSubCategories,
    setIsShowFullSubCategories,
}: {
    maxLengthOfDescendentCategories: number;
    maxLengthOfAbbreviatedDescendentList: number;
    isShowFullSubCategories: boolean;
    setIsShowFullSubCategories: Function;
}) => {
    const hasShowMoreButton =
        maxLengthOfDescendentCategories > maxLengthOfAbbreviatedDescendentList;

    if (!hasShowMoreButton) {
        return <></>;
    }

    return (
        <StyledShowMoreContainer
            onClick={() => {
                setIsShowFullSubCategories(!isShowFullSubCategories);
                trackGtmEvent({ action: 'FilterShowMoreClicked', label: 'Category' });
            }}
        >
            {isShowFullSubCategories
                ? 'Show less'
                : `Show ${
                      maxLengthOfDescendentCategories - maxLengthOfAbbreviatedDescendentList
                  } more`}
            <Icon
                type={isShowFullSubCategories ? 'chevron-u' : 'chevron-d'}
                size="smallest"
                className="chevron"
            />
        </StyledShowMoreContainer>
    );
};

export default ShowMoreToggle;
